const KEY = "thf.signature.profileOverrides";
const FIELDS = [
    "displayName",
    "jobTitle",
    "signOff",
    "mobilePhone",
    "businessPhone",
    "streetAddress",
    "city",
    "state",
    "postalCode",
];
/** Strip empty/whitespace fields so blanks fall back to Graph values server-side. */
export function pruneOverrides(o) {
    const out = {};
    for (const k of FIELDS) {
        const v = o[k];
        if (v != null && v.trim() !== "")
            out[k] = v.trim();
    }
    return out;
}
function readLocalStorage() {
    try {
        if (typeof localStorage === "undefined")
            return null;
        const raw = localStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : null;
    }
    catch {
        return null;
    }
}
function writeLocalStorage(o) {
    try {
        if (typeof localStorage === "undefined")
            return;
        localStorage.setItem(KEY, JSON.stringify(o));
    }
    catch {
        // storage may be sandboxed/unavailable
    }
}
async function readOfficeStorage() {
    try {
        if (typeof OfficeRuntime?.storage === "undefined")
            return null;
        const raw = await OfficeRuntime.storage.getItem(KEY);
        return raw ? JSON.parse(raw) : null;
    }
    catch {
        return null;
    }
}
async function writeOfficeStorage(o) {
    try {
        if (typeof OfficeRuntime?.storage === "undefined")
            return;
        await OfficeRuntime.storage.setItem(KEY, JSON.stringify(o));
    }
    catch {
        // storage may be sandboxed/unavailable
    }
}
/**
 * Load overrides from whichever store has them.
 * - In taskpane: localStorage usually has them (synchronous, reliable)
 * - In LaunchEvent runtime: only OfficeRuntime.storage is available
 */
export async function loadProfileOverrides() {
    const local = readLocalStorage();
    if (local) {
        console.log("[profile] loaded from localStorage:", local);
        return local;
    }
    const office = await readOfficeStorage();
    if (office) {
        console.log("[profile] loaded from OfficeRuntime.storage:", office);
        // Sync to localStorage so subsequent taskpane reads are sync-fast
        writeLocalStorage(office);
        return office;
    }
    console.log("[profile] no saved overrides");
    return {};
}
/** Write to both stores so taskpane and LaunchEvent runtime both see the latest. */
export async function saveProfileOverrides(o) {
    const pruned = pruneOverrides(o);
    writeLocalStorage(pruned);
    await writeOfficeStorage(pruned);
    console.log("[profile] saved:", pruned);
}
export async function clearProfileOverrides() {
    try {
        if (typeof localStorage !== "undefined")
            localStorage.removeItem(KEY);
    }
    catch {
        // non-fatal
    }
    try {
        if (typeof OfficeRuntime?.storage !== "undefined") {
            await OfficeRuntime.storage.removeItem(KEY);
        }
    }
    catch {
        // non-fatal
    }
    console.log("[profile] cleared");
}
